import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Card, CardHeader, CardContent, Stack, TableContainer, IconButton, Modal, Portal } from '@mui/material';
import OrderDetailsForm from './OrderDetailsForm';
import ParentAndParticipantForm from './ParentAndParticipantForm';
import AddPaymentModal from './AddPaymentModal';
import { Positions } from '../../Positions';
import AddIcon from '@mui/icons-material/Add';
import { SnackbarAlert } from '../../../../../../components-core/SnackbarAlert';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};


const OrderTab = ({ formik }) => {
  const { order } = useSelector(state => state.app);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [snackbar, setSnackbar] = React.useState({ open: false, severity: 'error', message: 'Wystąpił błąd' });

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  const handleOpenSnackbar = (severity, message) => setSnackbar({ open: true, severity, message });

  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <Box display="flex" flexDirection="row" justifyContent="space-between" mt={1} ml={2} mr={2}>
          <Stack flex="1 1 35%" mr={2}>
            <Card>
              <CardHeader
                title="Dane zamówienia"
                sx={{ mt: -1, mb: -2 }}
              />
              <CardContent>
                <OrderDetailsForm formik={formik}/>
              </CardContent>
            </Card>
          </Stack>
          <Stack flex="1 1 75%" mr={2}>
            <TableContainer component={Card}>
              <CardHeader
                title="Płatności"
                sx={{ mb: 1, mt: -1 }}
                action={
                  <IconButton onClick={handleOpen}>
                    <AddIcon />
                  </IconButton>
                }
              />
              <Positions positions={order.order_payments} order={order}/>
            </TableContainer>
            <ParentAndParticipantForm formik={formik} />
          </Stack>
        </Box>
      </form>
      <Modal
        open={open}
        onClose={handleClose}
      >
        <Card sx={{ ...style, width: '500px' }}>
          <CardHeader title="Dodaj płatność" />
          <CardContent>
            <AddPaymentModal order={order} handleClose={handleClose} handleOpenSnackbar={handleOpenSnackbar}/>
          </CardContent>
        </Card>
      </Modal>
      <Portal>
        <SnackbarAlert open={snackbar.open} severity={snackbar.severity} message={snackbar.message} onClose={handleCloseSnackbar} />
      </Portal>
    </Box>
  );
};

export default OrderTab;

